/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  CarTransportTruckGetParams,
  CarTransportTruckModel,
  CarTransportTruckModelBody,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useCarTransportTruckCreateHook = () => {
  const carTransportTruckCreate = useCustomInstance<CarTransportTruckModel>();

  return useCallback(
    (carTransportTruckModelBody: CarTransportTruckModelBody) => {
      return carTransportTruckCreate({
        url: `/api/CarTransportTruck/Create`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: carTransportTruckModelBody,
      });
    },
    [carTransportTruckCreate]
  );
};

export const useCarTransportTruckCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckCreateHook>>>,
    TError,
    { data: CarTransportTruckModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCarTransportTruckCreateHook>>>,
  TError,
  { data: CarTransportTruckModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const carTransportTruckCreate = useCarTransportTruckCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckCreateHook>>>,
    { data: CarTransportTruckModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return carTransportTruckCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CarTransportTruckCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCarTransportTruckCreateHook>>>
>;
export type CarTransportTruckCreateMutationBody = CarTransportTruckModelBody;
export type CarTransportTruckCreateMutationError = unknown;

export const useCarTransportTruckCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckCreateHook>>>,
    TError,
    { data: CarTransportTruckModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCarTransportTruckCreateHook>>>,
  TError,
  { data: CarTransportTruckModelBody },
  TContext
> => {
  const mutationOptions = useCarTransportTruckCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCarTransportTruckUpdateHook = () => {
  const carTransportTruckUpdate = useCustomInstance<CarTransportTruckModel>();

  return useCallback(
    (carTransportTruckModelBody: CarTransportTruckModelBody) => {
      return carTransportTruckUpdate({
        url: `/api/CarTransportTruck/Update`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: carTransportTruckModelBody,
      });
    },
    [carTransportTruckUpdate]
  );
};

export const useCarTransportTruckUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckUpdateHook>>>,
    TError,
    { data: CarTransportTruckModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCarTransportTruckUpdateHook>>>,
  TError,
  { data: CarTransportTruckModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const carTransportTruckUpdate = useCarTransportTruckUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckUpdateHook>>>,
    { data: CarTransportTruckModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return carTransportTruckUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CarTransportTruckUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCarTransportTruckUpdateHook>>>
>;
export type CarTransportTruckUpdateMutationBody = CarTransportTruckModelBody;
export type CarTransportTruckUpdateMutationError = unknown;

export const useCarTransportTruckUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckUpdateHook>>>,
    TError,
    { data: CarTransportTruckModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCarTransportTruckUpdateHook>>>,
  TError,
  { data: CarTransportTruckModelBody },
  TContext
> => {
  const mutationOptions = useCarTransportTruckUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useCarTransportTruckListHook = () => {
  const carTransportTruckList = useCustomInstance<CarTransportTruckModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return carTransportTruckList({
        url: `/api/CarTransportTruck/List`,
        method: 'GET',
        signal,
      });
    },
    [carTransportTruckList]
  );
};

export const getCarTransportTruckListQueryKey = () => {
  return [`/api/CarTransportTruck/List`] as const;
};

export const useCarTransportTruckListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCarTransportTruckListHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckListHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCarTransportTruckListQueryKey();

  const carTransportTruckList = useCarTransportTruckListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckListHook>>>
  > = ({ signal }) => carTransportTruckList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CarTransportTruckListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCarTransportTruckListHook>>>
>;
export type CarTransportTruckListQueryError = unknown;

export const useCarTransportTruckList = <
  TData = Awaited<ReturnType<ReturnType<typeof useCarTransportTruckListHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckListHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useCarTransportTruckListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useCarTransportTruckGetHook = () => {
  const carTransportTruckGet = useCustomInstance<CarTransportTruckModel>();

  return useCallback(
    (params?: CarTransportTruckGetParams, signal?: AbortSignal) => {
      return carTransportTruckGet({
        url: `/api/CarTransportTruck/Get`,
        method: 'GET',
        params,
        signal,
      });
    },
    [carTransportTruckGet]
  );
};

export const getCarTransportTruckGetQueryKey = (
  params?: CarTransportTruckGetParams
) => {
  return [`/api/CarTransportTruck/Get`, ...(params ? [params] : [])] as const;
};

export const useCarTransportTruckGetQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCarTransportTruckGetHook>>>,
  TError = unknown,
>(
  params?: CarTransportTruckGetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useCarTransportTruckGetHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCarTransportTruckGetQueryKey(params);

  const carTransportTruckGet = useCarTransportTruckGetHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckGetHook>>>
  > = ({ signal }) => carTransportTruckGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCarTransportTruckGetHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CarTransportTruckGetQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCarTransportTruckGetHook>>>
>;
export type CarTransportTruckGetQueryError = unknown;

export const useCarTransportTruckGet = <
  TData = Awaited<ReturnType<ReturnType<typeof useCarTransportTruckGetHook>>>,
  TError = unknown,
>(
  params?: CarTransportTruckGetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useCarTransportTruckGetHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useCarTransportTruckGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
